import { useCallback, useEffect, useRef } from 'react'

// Debounced autosave for editors that report every keystroke (e.g. task descriptions).
// The save function is captured when a change is scheduled, so a pending save always goes
// to the record it was typed into, even if the component switches records meanwhile.
// Pending changes are flushed on unmount.
export const useDebouncedSave = (save, delay = 800) => {
  const saveRef = useRef(save)
  saveRef.current = save
  const timer = useRef(null)
  const pending = useRef(null)

  const flush = useCallback(() => {
    clearTimeout(timer.current)
    const next = pending.current
    pending.current = null
    if (next) next.save(next.value)
  }, [])

  const schedule = useCallback((value) => {
    pending.current = { value, save: saveRef.current }
    clearTimeout(timer.current)
    timer.current = setTimeout(flush, delay)
  }, [delay, flush])

  useEffect(() => flush, [flush])

  return schedule
}
